// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   Reports Pages - Beautiful Styles
   ============================================ */

/* ============================================
   Reports List Page
   ============================================ */

.reports-page {
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8e8ff 100%);
}

.reports-grid {
  margin-top: 10px;
}

/* Report Card */
.report-card-beautiful {
  background: white;
  border: none;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  animation: slideUpReport 0.6s ease forwards;
  opacity: 0;
  transform: translateY(30px);
}

@keyframes slideUpReport {
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.report-card-beautiful:hover {
  transform: translateY(-10px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);
}

.report-card-beautiful.annual-report {
  border: 2px solid #ffd700;
}

.report-card-header {
  position: relative;
  padding: 30px 15px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.report-card-header::before {
  content: '';
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 200%;
  background: rgba(255, 255, 255, 0.1);
  transform: rotate(30deg);
  pointer-events: none;
}

.report-icon-wrapper {
  width: 60px;
  height: 60px;
  background: rgba(255, 255, 255, 0.25);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.report-icon-wrapper i {
  font-size: 28px;
  color: white;
}

.annual-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  background: linear-gradient(135deg, #ffd700 0%, #ffb700 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: pulse 2s infinite;
}

.annual-badge i {
  font-size: 14px;
  color: white;
}

.report-card-decoration {
  position: absolute;
  bottom: -20px;
  right: -20px;
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 50%;
}

.report-card-body {
  padding: 20px 15px;
  text-align: center;
}

.report-card-title {
  font-size: 14px;
  font-weight: 700;
  color: #333;
  margin: 0 0 12px 0;
  line-height: 1.3;
}

.report-card-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 13px;
  color: #667eea;
  font-weight: 600;
}

.report-card-action i {
  transition: transform 0.3s ease;
}

.report-card-beautiful:hover .report-card-action i {
  transform: translateX(5px);
}

/* ============================================
   Report Detail Pages
   ============================================ */

.report-page-beautiful {
  padding: 20px;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #e8e8ff 100%);
}

.report-card-container {
  border: none;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  background: white;
}

/* School Header */
.school-header-beautiful {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 40px 30px;
  text-align: center;
  position: relative;
  overflow: hidden;
}

.school-header-beautiful.single-exam {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.school-header-beautiful::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 60%);
  pointer-events: none;
}

.school-logo-placeholder {
  width: 80px;
  height: 80px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.school-logo-placeholder i {
  font-size: 40px;
  color: white;
}

.school-name-beautiful {
  font-size: 28px;
  font-weight: 700;
  color: white;
  margin: 0 0 10px 0;
}

.school-address-beautiful {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.85);
  margin: 0 0 20px 0;
}

.report-title-badge {
  display: inline-flex;
  align-items: center;
  padding: 10px 25px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 30px;
  color: white;
  font-weight: 600;
  font-size: 14px;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
}

.report-title-badge.exam-badge {
  background: rgba(255, 255, 255, 0.25);
}

/* Student Info */
.student-info-beautiful {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px;
  background: #f8f9fa;
  flex-wrap: wrap;
  gap: 20px;
}

.student-info-beautiful.with-stats {
  flex-direction: column;
}

.student-details-beautiful {
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
}

.detail-item {
  display: flex;
  flex-direction: column;
}

.detail-label {
  font-size: 12px;
  color: #888;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.detail-value {
  font-size: 18px;
  font-weight: 700;
  color: #333;
}

.student-photo-beautiful {
  display: flex;
  justify-content: center;
}

.photo-placeholder {
  width: 100px;
  height: 100px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);
}

.photo-placeholder i {
  font-size: 50px;
  color: white;
}

/* Report Stats Grid */
.report-stats-grid {
  display: flex;
  gap: 15px;
  margin-top: 20px;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.report-stat-card {
  background: white;
  border-radius: 16px;
  padding: 20px 30px;
  text-align: center;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
  min-width: 120px;
}

.report-stat-card .stat-value {
  font-size: 24px;
  font-weight: 700;
  color: #333;
}

.report-stat-card .stat-label {
  font-size: 12px;
  color: #888;
  margin-top: 4px;
}

.report-stat-card.percentage {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.report-stat-card.percentage .stat-value,
.report-stat-card.percentage .stat-label {
  color: white;
}

.report-stat-card.passed .stat-value {
  color: #11998e;
}

.report-stat-card.failed .stat-value {
  color: #ff416c;
}

/* Table Styles */
.table-wrapper-beautiful {
  padding: 20px;
  overflow-x: auto;
}

.report-table-beautiful {
  width: 100%;
  border-collapse: collapse;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);
}

.report-table-beautiful thead {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.single-exam-table thead {
  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.report-table-beautiful th {
  padding: 15px 12px;
  text-align: center;
  font-weight: 600;
  color: white;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.report-table-beautiful tbody tr {
  border-bottom: 1px solid #eee;
  animation: fadeInRow 0.4s ease forwards;
  opacity: 0;
  transition: background 0.3s ease;
}

.report-table-beautiful tbody tr:hover {
  background: #f8f9fa;
}

.report-table-beautiful td {
  padding: 15px 12px;
  text-align: center;
  font-size: 14px;
  color: #333;
}

.subject-name-cell {
  font-weight: 600;
  text-align: left !important;
}

.remarks-cell {
  font-size: 12px;
  color: #666;
  max-width: 150px;
}

.obtained-marks {
  font-weight: 700;
  color: #667eea;
}

/* Progress Cell */
.progress-cell {
  min-width: 120px;
}

.progress-wrapper {
  display: flex;
  align-items: center;
  gap: 10px;
}

.marks-progress {
  flex: 1 1;
  height: 8px;
  border-radius: 4px;
}

.progress-text {
  font-size: 12px;
  font-weight: 600;
  color: #666;
  min-width: 35px;
}

/* Grade Badge */
.grade-badge {
  display: inline-block;
  padding: 5px 12px;
  border-radius: 20px;
  color: white;
  font-weight: 600;
  font-size: 12px;
}

/* Status Badge */
.status-badge-report {
  display: inline-flex;
  align-items: center;
  padding: 5px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
}

.status-badge-report.pass {
  background: rgba(17, 153, 142, 0.15);
  color: #11998e;
}

.status-badge-report.fail {
  background: rgba(255, 65, 108, 0.15);
  color: #ff416c;
}

/* Grading Scale */
.grading-scale-beautiful {
  padding: 20px 30px;
  background: #f8f9fa;
}

.grading-title {
  font-size: 18px;
  font-weight: 700;
  color: #333;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.grading-title i {
  color: #667eea;
}

.grading-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 15px;
}

.grading-item {
  display: flex;
  align-items: center;
  gap: 15px;
  background: white;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);
  animation: fadeInRow 0.4s ease forwards;
  opacity: 0;
}

.grading-range {
  font-weight: 600;
  color: #333;
  min-width: 80px;
}

.grading-grade {
  padding: 5px 12px;
  border-radius: 20px;
  color: white;
  font-weight: 600;
  font-size: 12px;
  min-width: 40px;
  text-align: center;
}

.grading-remarks {
  font-size: 13px;
  color: #666;
  flex: 1 1;
}

/* Signatures */
.signatures-beautiful {
  display: flex;
  justify-content: space-around;
  padding: 40px 30px;
  flex-wrap: wrap;
  gap: 30px;
}

.signature-item {
  text-align: center;
}

.signature-line {
  width: 150px;
  height: 2px;
  background: #ddd;
  margin-bottom: 10px;
}

.signature-item p {
  font-size: 13px;
  color: #666;
  margin: 0;
}

/* Report Actions */
.report-actions {
  padding: 20px 30px 30px;
  text-align: center;
}

.print-button-beautiful {
  padding: 12px 30px;
  border-radius: 12px;
  font-weight: 600;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: all 0.3s ease;
}

.print-button-beautiful:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);
}

/* ============================================
   Responsive Styles
   ============================================ */

@media (max-width: 991.98px) {
  .student-details-beautiful {
    justify-content: center;
  }

  .grading-grid {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 767.98px) {
  .reports-page,
  .report-page-beautiful {
    padding: 15px;
  }

  .report-card-header {
    padding: 25px 15px;
  }

  .report-icon-wrapper {
    width: 50px;
    height: 50px;
  }

  .report-icon-wrapper i {
    font-size: 22px;
  }

  .report-card-title {
    font-size: 13px;
  }

  .school-header-beautiful {
    padding: 30px 20px;
  }

  .school-name-beautiful {
    font-size: 22px;
  }

  .school-logo-placeholder {
    width: 60px;
    height: 60px;
  }

  .school-logo-placeholder i {
    font-size: 30px;
  }

  .student-info-beautiful {
    padding: 20px;
  }

  .student-details-beautiful {
    gap: 20px;
  }

  .detail-value {
    font-size: 16px;
  }

  .photo-placeholder {
    width: 80px;
    height: 80px;
  }

  .photo-placeholder i {
    font-size: 40px;
  }

  .report-stats-grid {
    gap: 10px;
  }

  .report-stat-card {
    padding: 15px 20px;
    min-width: 100px;
  }

  .report-stat-card .stat-value {
    font-size: 20px;
  }

  .table-wrapper-beautiful {
    padding: 15px;
  }

  .report-table-beautiful th,
  .report-table-beautiful td {
    padding: 12px 8px;
    font-size: 12px;
  }

  .signatures-beautiful {
    padding: 30px 20px;
    gap: 20px;
  }

  .signature-line {
    width: 120px;
  }

  .grading-scale-beautiful {
    padding: 20px;
  }
}

@media (max-width: 575.98px) {
  .reports-page,
  .report-page-beautiful {
    padding: 10px;
  }

  .school-header-beautiful {
    padding: 25px 15px;
  }

  .school-name-beautiful {
    font-size: 18px;
  }

  .school-address-beautiful {
    font-size: 12px;
  }

  .report-title-badge {
    font-size: 12px;
    padding: 8px 16px;
  }

  .student-info-beautiful {
    padding: 15px;
  }

  .detail-label {
    font-size: 10px;
  }

  .detail-value {
    font-size: 14px;
  }

  .photo-placeholder {
    width: 70px;
    height: 70px;
  }

  .photo-placeholder i {
    font-size: 35px;
  }

  .report-stat-card {
    padding: 12px 15px;
    min-width: 80px;
  }

  .report-stat-card .stat-value {
    font-size: 18px;
  }

  .report-stat-card .stat-label {
    font-size: 10px;
  }

  .report-table-beautiful th,
  .report-table-beautiful td {
    padding: 10px 6px;
    font-size: 11px;
  }

  .grade-badge {
    padding: 4px 8px;
    font-size: 10px;
  }

  .status-badge-report {
    padding: 4px 8px;
    font-size: 10px;
  }

  .grading-item {
    flex-direction: column;
    text-align: center;
    gap: 10px;
  }

  .grading-range {
    min-width: auto;
  }

  .signatures-beautiful {
    flex-direction: column;
    align-items: center;
  }
}

/* Print Styles */
@media print {
  .page-header-beautiful,
  .print-button-beautiful,
  .report-actions,
  .header-back-btn {
    display: none !important;
  }

  .report-page-beautiful {
    padding: 0;
    background: white;
  }

  .report-card-container {
    box-shadow: none;
    border-radius: 0;
  }

  .school-header-beautiful {
    background: #333 !important;
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/dashboards/components/reports-beautiful.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD;;iDAEiD;;AAEjD;EACE,aAAa;EACb,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;EAC1C,eAAe;EACf,4DAA4D;EAC5D,2CAA2C;EAC3C,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,4BAA4B;EAC5B,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qCAAqC;EACrC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;iDAEiD;;AAEjD;EACE,aAAa;EACb,iBAAiB;EACjB,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8EAA8E;EAC9E,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mCAA2B;UAA3B,2BAA2B;AAC7B;;AAEA;EACE,qCAAqC;AACvC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,6DAA6D;EAC7D,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,uCAAuC;EACvC,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,gBAAgB;AAChB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,uCAAuC;EACvC,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAO;AACT;;AAEA,eAAe;AACf;EACE,aAAa;EACb,6BAA6B;EAC7B,kBAAkB;EAClB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA,mBAAmB;AACnB;EACE,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,6DAA6D;EAC7D,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;;iDAEiD;;AAEjD;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,iBAAiB;IACjB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA,iBAAiB;AACjB;EACE;;;;IAIE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,2BAA2B;IAC3B,iCAAiC;IACjC,yBAAyB;EAC3B;AACF","sourcesContent":["/* ============================================\n   Reports Pages - Beautiful Styles\n   ============================================ */\n\n/* ============================================\n   Reports List Page\n   ============================================ */\n\n.reports-page {\n  padding: 20px;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8e8ff 100%);\n}\n\n.reports-grid {\n  margin-top: 10px;\n}\n\n/* Report Card */\n.report-card-beautiful {\n  background: white;\n  border: none;\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  animation: slideUpReport 0.6s ease forwards;\n  opacity: 0;\n  transform: translateY(30px);\n}\n\n@keyframes slideUpReport {\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.report-card-beautiful:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.15);\n}\n\n.report-card-beautiful.annual-report {\n  border: 2px solid #ffd700;\n}\n\n.report-card-header {\n  position: relative;\n  padding: 30px 15px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.report-card-header::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  right: -50%;\n  width: 100%;\n  height: 200%;\n  background: rgba(255, 255, 255, 0.1);\n  transform: rotate(30deg);\n  pointer-events: none;\n}\n\n.report-icon-wrapper {\n  width: 60px;\n  height: 60px;\n  background: rgba(255, 255, 255, 0.25);\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  backdrop-filter: blur(10px);\n}\n\n.report-icon-wrapper i {\n  font-size: 28px;\n  color: white;\n}\n\n.annual-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 30px;\n  height: 30px;\n  background: linear-gradient(135deg, #ffd700 0%, #ffb700 100%);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  animation: pulse 2s infinite;\n}\n\n.annual-badge i {\n  font-size: 14px;\n  color: white;\n}\n\n.report-card-decoration {\n  position: absolute;\n  bottom: -20px;\n  right: -20px;\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 50%;\n}\n\n.report-card-body {\n  padding: 20px 15px;\n  text-align: center;\n}\n\n.report-card-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #333;\n  margin: 0 0 12px 0;\n  line-height: 1.3;\n}\n\n.report-card-action {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  font-size: 13px;\n  color: #667eea;\n  font-weight: 600;\n}\n\n.report-card-action i {\n  transition: transform 0.3s ease;\n}\n\n.report-card-beautiful:hover .report-card-action i {\n  transform: translateX(5px);\n}\n\n/* ============================================\n   Report Detail Pages\n   ============================================ */\n\n.report-page-beautiful {\n  padding: 20px;\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #e8e8ff 100%);\n}\n\n.report-card-container {\n  border: none;\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);\n  overflow: hidden;\n  background: white;\n}\n\n/* School Header */\n.school-header-beautiful {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  padding: 40px 30px;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n\n.school-header-beautiful.single-exam {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n}\n\n.school-header-beautiful::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 60%);\n  pointer-events: none;\n}\n\n.school-logo-placeholder {\n  width: 80px;\n  height: 80px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 20px;\n  backdrop-filter: blur(10px);\n}\n\n.school-logo-placeholder i {\n  font-size: 40px;\n  color: white;\n}\n\n.school-name-beautiful {\n  font-size: 28px;\n  font-weight: 700;\n  color: white;\n  margin: 0 0 10px 0;\n}\n\n.school-address-beautiful {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.85);\n  margin: 0 0 20px 0;\n}\n\n.report-title-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 10px 25px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 30px;\n  color: white;\n  font-weight: 600;\n  font-size: 14px;\n  backdrop-filter: blur(10px);\n}\n\n.report-title-badge.exam-badge {\n  background: rgba(255, 255, 255, 0.25);\n}\n\n/* Student Info */\n.student-info-beautiful {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 30px;\n  background: #f8f9fa;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n\n.student-info-beautiful.with-stats {\n  flex-direction: column;\n}\n\n.student-details-beautiful {\n  display: flex;\n  gap: 30px;\n  flex-wrap: wrap;\n}\n\n.detail-item {\n  display: flex;\n  flex-direction: column;\n}\n\n.detail-label {\n  font-size: 12px;\n  color: #888;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 4px;\n}\n\n.detail-value {\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n}\n\n.student-photo-beautiful {\n  display: flex;\n  justify-content: center;\n}\n\n.photo-placeholder {\n  width: 100px;\n  height: 100px;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border-radius: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.3);\n}\n\n.photo-placeholder i {\n  font-size: 50px;\n  color: white;\n}\n\n/* Report Stats Grid */\n.report-stats-grid {\n  display: flex;\n  gap: 15px;\n  margin-top: 20px;\n  flex-wrap: wrap;\n  justify-content: center;\n  width: 100%;\n}\n\n.report-stat-card {\n  background: white;\n  border-radius: 16px;\n  padding: 20px 30px;\n  text-align: center;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n  min-width: 120px;\n}\n\n.report-stat-card .stat-value {\n  font-size: 24px;\n  font-weight: 700;\n  color: #333;\n}\n\n.report-stat-card .stat-label {\n  font-size: 12px;\n  color: #888;\n  margin-top: 4px;\n}\n\n.report-stat-card.percentage {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.report-stat-card.percentage .stat-value,\n.report-stat-card.percentage .stat-label {\n  color: white;\n}\n\n.report-stat-card.passed .stat-value {\n  color: #11998e;\n}\n\n.report-stat-card.failed .stat-value {\n  color: #ff416c;\n}\n\n/* Table Styles */\n.table-wrapper-beautiful {\n  padding: 20px;\n  overflow-x: auto;\n}\n\n.report-table-beautiful {\n  width: 100%;\n  border-collapse: collapse;\n  border-radius: 12px;\n  overflow: hidden;\n  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.08);\n}\n\n.report-table-beautiful thead {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n}\n\n.single-exam-table thead {\n  background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);\n}\n\n.report-table-beautiful th {\n  padding: 15px 12px;\n  text-align: center;\n  font-weight: 600;\n  color: white;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.report-table-beautiful tbody tr {\n  border-bottom: 1px solid #eee;\n  animation: fadeInRow 0.4s ease forwards;\n  opacity: 0;\n  transition: background 0.3s ease;\n}\n\n.report-table-beautiful tbody tr:hover {\n  background: #f8f9fa;\n}\n\n.report-table-beautiful td {\n  padding: 15px 12px;\n  text-align: center;\n  font-size: 14px;\n  color: #333;\n}\n\n.subject-name-cell {\n  font-weight: 600;\n  text-align: left !important;\n}\n\n.remarks-cell {\n  font-size: 12px;\n  color: #666;\n  max-width: 150px;\n}\n\n.obtained-marks {\n  font-weight: 700;\n  color: #667eea;\n}\n\n/* Progress Cell */\n.progress-cell {\n  min-width: 120px;\n}\n\n.progress-wrapper {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.marks-progress {\n  flex: 1;\n  height: 8px;\n  border-radius: 4px;\n}\n\n.progress-text {\n  font-size: 12px;\n  font-weight: 600;\n  color: #666;\n  min-width: 35px;\n}\n\n/* Grade Badge */\n.grade-badge {\n  display: inline-block;\n  padding: 5px 12px;\n  border-radius: 20px;\n  color: white;\n  font-weight: 600;\n  font-size: 12px;\n}\n\n/* Status Badge */\n.status-badge-report {\n  display: inline-flex;\n  align-items: center;\n  padding: 5px 12px;\n  border-radius: 20px;\n  font-size: 12px;\n  font-weight: 600;\n}\n\n.status-badge-report.pass {\n  background: rgba(17, 153, 142, 0.15);\n  color: #11998e;\n}\n\n.status-badge-report.fail {\n  background: rgba(255, 65, 108, 0.15);\n  color: #ff416c;\n}\n\n/* Grading Scale */\n.grading-scale-beautiful {\n  padding: 20px 30px;\n  background: #f8f9fa;\n}\n\n.grading-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: #333;\n  margin-bottom: 20px;\n  display: flex;\n  align-items: center;\n}\n\n.grading-title i {\n  color: #667eea;\n}\n\n.grading-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 15px;\n}\n\n.grading-item {\n  display: flex;\n  align-items: center;\n  gap: 15px;\n  background: white;\n  padding: 15px;\n  border-radius: 12px;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.05);\n  animation: fadeInRow 0.4s ease forwards;\n  opacity: 0;\n}\n\n.grading-range {\n  font-weight: 600;\n  color: #333;\n  min-width: 80px;\n}\n\n.grading-grade {\n  padding: 5px 12px;\n  border-radius: 20px;\n  color: white;\n  font-weight: 600;\n  font-size: 12px;\n  min-width: 40px;\n  text-align: center;\n}\n\n.grading-remarks {\n  font-size: 13px;\n  color: #666;\n  flex: 1;\n}\n\n/* Signatures */\n.signatures-beautiful {\n  display: flex;\n  justify-content: space-around;\n  padding: 40px 30px;\n  flex-wrap: wrap;\n  gap: 30px;\n}\n\n.signature-item {\n  text-align: center;\n}\n\n.signature-line {\n  width: 150px;\n  height: 2px;\n  background: #ddd;\n  margin-bottom: 10px;\n}\n\n.signature-item p {\n  font-size: 13px;\n  color: #666;\n  margin: 0;\n}\n\n/* Report Actions */\n.report-actions {\n  padding: 20px 30px 30px;\n  text-align: center;\n}\n\n.print-button-beautiful {\n  padding: 12px 30px;\n  border-radius: 12px;\n  font-weight: 600;\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  border: none;\n  transition: all 0.3s ease;\n}\n\n.print-button-beautiful:hover {\n  transform: translateY(-3px);\n  box-shadow: 0 10px 30px rgba(102, 126, 234, 0.4);\n}\n\n/* ============================================\n   Responsive Styles\n   ============================================ */\n\n@media (max-width: 991.98px) {\n  .student-details-beautiful {\n    justify-content: center;\n  }\n\n  .grading-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .reports-page,\n  .report-page-beautiful {\n    padding: 15px;\n  }\n\n  .report-card-header {\n    padding: 25px 15px;\n  }\n\n  .report-icon-wrapper {\n    width: 50px;\n    height: 50px;\n  }\n\n  .report-icon-wrapper i {\n    font-size: 22px;\n  }\n\n  .report-card-title {\n    font-size: 13px;\n  }\n\n  .school-header-beautiful {\n    padding: 30px 20px;\n  }\n\n  .school-name-beautiful {\n    font-size: 22px;\n  }\n\n  .school-logo-placeholder {\n    width: 60px;\n    height: 60px;\n  }\n\n  .school-logo-placeholder i {\n    font-size: 30px;\n  }\n\n  .student-info-beautiful {\n    padding: 20px;\n  }\n\n  .student-details-beautiful {\n    gap: 20px;\n  }\n\n  .detail-value {\n    font-size: 16px;\n  }\n\n  .photo-placeholder {\n    width: 80px;\n    height: 80px;\n  }\n\n  .photo-placeholder i {\n    font-size: 40px;\n  }\n\n  .report-stats-grid {\n    gap: 10px;\n  }\n\n  .report-stat-card {\n    padding: 15px 20px;\n    min-width: 100px;\n  }\n\n  .report-stat-card .stat-value {\n    font-size: 20px;\n  }\n\n  .table-wrapper-beautiful {\n    padding: 15px;\n  }\n\n  .report-table-beautiful th,\n  .report-table-beautiful td {\n    padding: 12px 8px;\n    font-size: 12px;\n  }\n\n  .signatures-beautiful {\n    padding: 30px 20px;\n    gap: 20px;\n  }\n\n  .signature-line {\n    width: 120px;\n  }\n\n  .grading-scale-beautiful {\n    padding: 20px;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .reports-page,\n  .report-page-beautiful {\n    padding: 10px;\n  }\n\n  .school-header-beautiful {\n    padding: 25px 15px;\n  }\n\n  .school-name-beautiful {\n    font-size: 18px;\n  }\n\n  .school-address-beautiful {\n    font-size: 12px;\n  }\n\n  .report-title-badge {\n    font-size: 12px;\n    padding: 8px 16px;\n  }\n\n  .student-info-beautiful {\n    padding: 15px;\n  }\n\n  .detail-label {\n    font-size: 10px;\n  }\n\n  .detail-value {\n    font-size: 14px;\n  }\n\n  .photo-placeholder {\n    width: 70px;\n    height: 70px;\n  }\n\n  .photo-placeholder i {\n    font-size: 35px;\n  }\n\n  .report-stat-card {\n    padding: 12px 15px;\n    min-width: 80px;\n  }\n\n  .report-stat-card .stat-value {\n    font-size: 18px;\n  }\n\n  .report-stat-card .stat-label {\n    font-size: 10px;\n  }\n\n  .report-table-beautiful th,\n  .report-table-beautiful td {\n    padding: 10px 6px;\n    font-size: 11px;\n  }\n\n  .grade-badge {\n    padding: 4px 8px;\n    font-size: 10px;\n  }\n\n  .status-badge-report {\n    padding: 4px 8px;\n    font-size: 10px;\n  }\n\n  .grading-item {\n    flex-direction: column;\n    text-align: center;\n    gap: 10px;\n  }\n\n  .grading-range {\n    min-width: auto;\n  }\n\n  .signatures-beautiful {\n    flex-direction: column;\n    align-items: center;\n  }\n}\n\n/* Print Styles */\n@media print {\n  .page-header-beautiful,\n  .print-button-beautiful,\n  .report-actions,\n  .header-back-btn {\n    display: none !important;\n  }\n\n  .report-page-beautiful {\n    padding: 0;\n    background: white;\n  }\n\n  .report-card-container {\n    box-shadow: none;\n    border-radius: 0;\n  }\n\n  .school-header-beautiful {\n    background: #333 !important;\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
